import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { IMyDpOptions } from 'mydatepicker';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { AggregatorTransactionBO, GetCaregiverLogsBo } from './caregiver-logs.modal';
import { CaregiverLogsService } from './caregiver-logs.service';

@Component({
  selector: 'app-caregiver-logs',
  templateUrl: './caregiver-logs.component.html',
  styleUrls: ['./caregiver-logs.component.scss']
})

export class CaregiverLogsComponent implements OnInit {
  @ViewChild('gridCaregiverLogs') public gridCaregiverLogs: GridComponent;
  @ViewChild('gridErrorLogs') public gridErrorLogs: GridComponent;

  ErrorDataList: any = [];
  RequestPayload: any = [];
  RequestContent: any = [];
  CaregiverData: any = [];
  arraycol: any = []

  private onDestroy$: Subject<void> = new Subject<void>();
  public GridDataList: Observable<DataStateChangeEventArgs>;

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 1,
    },
    showClearDateBtn: true,
    editableDateField: true,
  }

  id: string = "00000000-0000-0000-0000-000000000000";
  type: string = "";
  ;
  public filterSettings: object;
  public formatOptions: Object;
  initialPage: object;
  public wrapSettings: TextWrapSettingsModel;
  ErrorinitialPage: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  CaregiverLogsBo: AggregatorTransactionBO = new AggregatorTransactionBO();
  fromDate: any;
  toDate: any;

  constructor(public CgService: CaregiverLogsService, public global: GlobalComponent, public dateservice: DateService) {
    this.GridDataList = CgService;
  }
  ngOnInit(): void {
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.formatOptions = { type: 'datetime', format: 'MM/dd/yyyy h:mm:ss a' };
    this.filterSettings = { type: 'Menu' };
    this.ErrorinitialPage = { pageSize: 10 };
    this.wrapSettings = { wrapMode: 'Content' };
    this.initialPage = {
      pageSizes: ["10", "20", "50", "100", "250"],
      pageSize: 10,
    };
    this.getCaregiverLogsFilter();
  }
  //...................................................onActionComplete........................................................
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridCaregiverLogs.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Caregiver_Logs.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].Caregiver_Logs.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].Caregiver_Logs.ShowColumns.length != count1 || this.arraycol[0].Caregiver_Logs.HideColumns.length != count) {
            this.arraycol[0].Caregiver_Logs.ShowColumns = showarr;
            this.arraycol[0].Caregiver_Logs.HideColumns = hidearr;
          }
        }
      }
    }
    this.CaregiverLogsBo.currentpageno = this.gridCaregiverLogs.pagerModule.pagerObj.currentPage;
    this.CaregiverLogsBo.pageitem = this.gridCaregiverLogs.pagerModule.pagerObj.pageSize;
  }

  //................................................... dataStateChange.................................................
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.CaregiverLogsBo.orderColumn = state.sorted[0].name;
        this.CaregiverLogsBo.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.CaregiverLogsBo.field = state.action.currentFilterObject.field;
      this.CaregiverLogsBo.matchCase = state.action.currentFilterObject.matchCase;
      this.CaregiverLogsBo.operator = state.action.currentFilterObject.operator;
      this.CaregiverLogsBo.value = state.action.currentFilterObject.value;
      if (this.CaregiverLogsBo.type == "number") {
        this.CaregiverLogsBo.value = state.action.currentFilterObject.value.toString();
        this.CaregiverLogsBo.field = state.action.currentFilterObject.field;
      }
      else if (this.CaregiverLogsBo.type == "datetime") {
        this.CaregiverLogsBo.value = this.global.getDateTimeString(state.action.currentFilterObject.value);
        this.CaregiverLogsBo.field = state.action.currentFilterObject.field;
      }
      else {
        this.CaregiverLogsBo.value = state.action.currentFilterObject.value;
        this.CaregiverLogsBo.field = state.action.currentFilterObject.field;
      }
      this.CaregiverLogsBo.matchCase = state.action.currentFilterObject.matchCase;
      this.CaregiverLogsBo.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.CaregiverLogsBo.field = "companyName";
        this.CaregiverLogsBo.matchCase = false;
        this.CaregiverLogsBo.operator = "startswith";
        this.CaregiverLogsBo.value = "";
        this.CaregiverLogsBo.type = "string";
      }
    }
    if (this.type != "refresh") {
      this.getCaregiverLogsFilter();
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Caregiver_Logs.Pagesize != state.take) {
          this.arraycol[0].Caregiver_Logs.Pagesize = state.take
        }
      }
    }
  }
  //.............................................onResize.................................................................
  onResize(args) {
    const column = this.gridCaregiverLogs.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.gridCaregiverLogs.refreshHeader();
  }

  //..........................................getErrorList.....................................................
  public getErrorList(Id) {
    let params = new URLSearchParams();
    params.append("Id", Id);
    this.CgService.GetErrorList(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ErrorDataList = data.errors;
    },
      (err: any) => {
        if (err) {
        }
      })
  }
  //..........................................getCaregiverLogsFilter.....................................................
  getCaregiverLogsFilter() {
    this.CaregiverData.statusType = (this.CaregiverData.statusType != '' && this.CaregiverData.statusType != undefined && this.CaregiverData.statusType != null) ? this.CaregiverData.statusType : null;
    this.CaregiverLogsBo.statusType=this.CaregiverData.statusType;
    this.CaregiverData.startDate = this.fromDate;
    this.CaregiverData.endDate = this.toDate;
    this.CaregiverData.startDate =
      this.CaregiverData.startDate != null &&
        this.CaregiverData.startDate != undefined &&
        this.CaregiverData.startDate != ""
        ? this.global.getDateTimeString(this.CaregiverData.startDate)
        : null;
    this.CaregiverData.endDate =
      this.CaregiverData.endDate != null &&
        this.CaregiverData.endDate != undefined &&
        this.CaregiverData.endDate != ""
        ? this.global.getDateTimeString(this.CaregiverData.endDate)
        : null;
    this.CaregiverLogsBo.startDate=this.CaregiverData.startDate;
    this.CaregiverLogsBo.endDate=this.CaregiverData.endDate;

    this.CgService.outputlogs(this.CaregiverLogsBo);
    let count = 0
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.CaregiverData = data.result;
      count = count + 1;
      if (this.global.globalAgencyId != null && this.global.globalAgencyId != "00000000-0000-0000-0000-000000000000") {
        if (data != null && data.result.length > 15) {
          this.gridCaregiverLogs.height = '500';
        }
        else {
          this.gridCaregiverLogs.height = 'auto';
        }
      }
    })
  }

  showorhidecolumns() {
    this.gridCaregiverLogs.openColumnChooser(200, 50);
  }

  getRequestPayload(Payload) {
    this.RequestPayload = Payload;
  }

  getRequestContent(content) {
    this.RequestContent = content;
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == "FromDate") {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let datevalue = this.dateservice.inputFeildchangeReturnall(event);
          this.fromDate = datevalue;
        }
      }
      if (name == "ToDate") {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let datevalue = this.dateservice.inputFeildchangeReturnall(event);
          this.toDate = datevalue;
        }
      }
    }
    if (type == "datechanged") {
      if (name == "FromDate") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let datevalue = this.dateservice.Datechange(event);
          this.fromDate = datevalue;
        }
      }
    }
    if (name == "ToDate") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let datevalue = this.dateservice.Datechange(event);
        this.toDate = datevalue;
      }
    }
  }

  filterApply() {
    this.CaregiverData.startDate = this.fromDate;
    this.CaregiverData.endDate = this.toDate;
    this.CaregiverData.startDate =
      this.CaregiverData.startDate != null &&
        this.CaregiverData.startDate != undefined &&
        this.CaregiverData.startDate != ""
        ? this.global.getDateTimeString(this.CaregiverData.startDate)
        : null;
    this.CaregiverData.endDate =
      this.CaregiverData.endDate != null &&
        this.CaregiverData.endDate != undefined &&
        this.CaregiverData.endDate != ""
        ? this.global.getDateTimeString(this.CaregiverData.endDate)
        : null;

    this.getCaregiverLogsFilter();
  }

}